import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';
import { AuthenticationService } from '../../providers/authentication/authenticationService';
import { Config } from '../../providers/config';
import { ConfigService } from '../../providers/config/config.service';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';

@Component({
  selector: 'page-configuration',
  templateUrl: 'configuration.html',
  providers: [ConfigService],
})
export class ConfigurationPage {
  public isBrokerConnected: boolean;
  private configuration: Config;
  private brokerConnectionChangeSubscription: Subscription;

  get orderStatus(): string {
    return this.phaseBS.getValue();
  }

  set orderStatus(value: string) {
    this.phaseBS.next(value);
  }

  // private orders: User[];
  private phaseBS: BehaviorSubject<string>;

  constructor(
    public navCtrl: NavController,
    private configService: ConfigService,
    private authenticationService: AuthenticationService,
    private paytronBackendService: PaytronBackendService
  ) {}

  ngOnInit() {
    // this.configService.getConfig('./config.json').then(
    //   config => {
    //
    //     this.configuration = config;
    //   }
    // );

    this.phaseBS = new BehaviorSubject<string>('');
    this.phaseBS.next('surgery');
    // this.orderStatusBS.subscribe((orderType: string) => {
    //   this.paytron-backendService.getOrdersByPhase(orderType)
    // })

    this.authenticationService.login('John.Doctor', 'doctor').subscribe((result) => {});
  }

  // getPatients(searchText) {
  //   this.paytron-backendService.getPatients(searchText.target.value).subscribe(patients => {
  //     this.patients = patients;
  //   });
  // }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration.ts